export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 rounded-3xl bg-gradient-to-br from-primary-500 via-primary-600 to-accent-600 p-8 md:p-12 lg:p-16 overflow-hidden relative">
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_rgba(255,255,255,0.15),transparent_60%)]"></div>

          <div className="flex-1 w-full relative z-10 text-center lg:text-left">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-4">
              随时随地，畅享韩漫
            </h2>
            <p className="text-sm md:text-base text-background-50/90 leading-relaxed mb-6 max-w-lg mx-auto lg:mx-0">
              韩漫屋移动端完美适配手机竖屏阅读，下拉式流畅体验让你随时随地畅享韩漫全集免费阅读。打开浏览器即可使用，无需下载安装。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                className="w-full sm:w-auto px-8 py-3.5 rounded-xl bg-background-50 text-primary-600 font-semibold text-sm md:text-base hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer no-underline text-center"
              >
                <i className="ri-smartphone-line mr-2"></i>
                立即体验移动版
              </a>
              <span className="text-xs text-background-50/70 whitespace-nowrap">
                无需下载 · 打开即看
              </span>
            </div>
          </div>

          <div className="flex-1 w-full relative z-10 flex justify-center">
            <div className="relative w-full max-w-[300px] aspect-[9/16] rounded-2xl overflow-hidden border-4 border-background-50/30">
              <img
                src="https://readdy.ai/api/search-image?query=Mobile%20phone%20screen%20mockup%20displaying%20Korean%20manhwa%20webtoon%20reading%20interface%20with%20vertical%20scroll%20layout%2C%20colorful%20comic%20panels%2C%20clean%20UI%20design%2C%20warm%20coral%20and%20cream%20color%20palette%2C%20modern%20app%20interface%20aesthetic%2C%20sleek%20minimal%20design&width=600&height=1066&seq=app-mobile-mockup&orientation=portrait"
                alt="韩漫屋移动版阅读界面"
                className="w-full h-full object-cover"
                onError={(e) => {
                  (e.target as HTMLElement).style.display = 'none';
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}